// extracted by mini-css-extract-plugin
module.exports = {"switchWrapper":"Form_switchWrapper__kUP8A","formWrapper":"Form_formWrapper__9xe1g"};